import PropTypes from 'prop-types';

import BatteryActive from 'assets/algorithm_insights_icons/Battery-active.svg?react';
import Battery from 'assets/algorithm_insights_icons/Battery.svg?react';
import BrakesActive from 'assets/algorithm_insights_icons/Brake-active.svg?react';
import Brakes from 'assets/algorithm_insights_icons/Brake.svg?react';
import CrankingVoltageActive from 'assets/algorithm_insights_icons/Cranking-voltage-active.svg?react';
import CrankingVoltage from 'assets/algorithm_insights_icons/Cranking-voltage.svg?react';
import DEFLevelActive from 'assets/algorithm_insights_icons/DEF-level-active.svg?react';
import DEFLevel from 'assets/algorithm_insights_icons/DEF-level.svg?react';
import DEFSystemActive from 'assets/algorithm_insights_icons/DEF-system-active.svg?react';
import DEFSystem from 'assets/algorithm_insights_icons/DEF-system.svg?react';
import SensorActive from 'assets/algorithm_insights_icons/Sensor-active.svg?react';
import Sensor from 'assets/algorithm_insights_icons/Sensor.svg?react';

const AlgorithmIconSelector = (props) => {
  if (props.selected) {
    if (props.iconName === 'Battery') {
      return <BatteryActive />;
    }
    if (props.iconName === 'Brakes') {
      return <BrakesActive />;
    }
    if (props.iconName === 'Fluids') {
      return <DEFLevelActive />;
    }
    if (props.iconName === 'Diesel Exhaust Fluid') {
      return <DEFLevelActive />;
    }
    if (props.iconName === 'Cranking Voltage') {
      return <CrankingVoltageActive />;
    }
    if (props.iconName === 'Sensor Health') {
      return <SensorActive />;
    }
    if (props.iconName === 'DEF System') {
      return <DEFSystemActive />;
    }
    if (props.iconName === 'Parked Vehicle  Battery') {
      return <BatteryActive />;
    }
    return <SensorActive />;
  } else if (!props.selected) {
    if (props.iconName === 'Battery') {
      return <Battery />;
    }
    if (props.iconName === 'Brakes') {
      return <Brakes />;
    }
    if (props.iconName === 'Fluids') {
      return <DEFLevel />;
    }
    if (props.iconName === 'Diesel Exhaust Fluid') {
      return <DEFLevel />;
    }
    if (props.iconName === 'Cranking Voltage') {
      return <CrankingVoltage />;
    }
    if (props.iconName === 'Sensor Health') {
      return <Sensor />;
    }
    if (props.iconName === 'DEF System') {
      return <DEFSystem />;
    }
    if (props.iconName === 'Parked Vehicle  Battery') {
      return <Battery />;
    }
    return <Sensor />;
  }
  return null;
};

AlgorithmIconSelector.propTypes = {
  selected: PropTypes.bool,
  iconName: PropTypes.string,
};

export default AlgorithmIconSelector;
